import React from "react";
import UnitCountSix from "./child/UnitCountSix";

const DashBoardLayerEight = () => {
  return (
    <>
      <div className="row gy-4">
        <div className="col-xxxl-12">
          <div className="row gy-4">
            <UnitCountSix />
          </div>
        </div>
      </div>
    </>
  );
};

export default DashBoardLayerEight;
